import PropTypes from 'prop-types';
import classes from "./Slide.module.scss";
import clsx from 'clsx';
import { useEffect, useRef } from 'react';
import { AudioComponentControl } from '@educaplay/core/components/AudioComponentControl';
import { ImageComponent, YouTubeComponent } from '@educaplay/core';

export default function SlideMultimedia(props) {
    const { type, title, source, className, freeze } = props;
    const mediaKey = useRef(0);

    useEffect(() => {
        if (freeze) {
            // Increment key to force re-render of multimedia
            mediaKey.current++;
        }
    }, [freeze]);

    return (
        <div className={clsx(classes.mediaColumn, freeze && classes.freeze, className)}>
            {type === 'image' && (
                <div className={classes.imageWrapper}>
                    <ImageComponent className={classes.image} source={source} />
                </div>
            )}

            {type === 'youtube' && (
                <div className={classes.youtubeWrapper} key={`youtube-${mediaKey.current}`}>
                    <YouTubeComponent url={source} />
                </div>
            )}

            {type === 'audio' && (
                <div className={classes.audioWrapper} key={`audio-${mediaKey.current}`}>
                    <AudioComponentControl source={source} big />
                </div>
            )}

            {title && <h3 className={classes.figcaption}>{title}</h3>}
        </div>
    )
}

SlideMultimedia.propTypes = {
    type: PropTypes.oneOf(['image', 'youtube', 'audio']).isRequired,
    title: PropTypes.string,
    source: PropTypes.string.isRequired,
    className: PropTypes.string,
    freeze: PropTypes.bool
}